import React from 'react'
import Subtitle from './Subtitle'
interface TitleProps {
  title: string
  subtitle?: string
}
const Title: React.FC<TitleProps> = ({ title, subtitle }: TitleProps) => {
  return (
    <div className="section py-5">
      <h1 className="title is-3 container">{title}</h1>
      {subtitle && <Subtitle subtitle={subtitle} />}
    </div>
  )
}

export default Title
